import logoUrl from "@/assets/resetdata-logo.svg";
import { cn } from "@/lib/utils";

/**
 * ResetData wordmark (coral #e73452 — matches --primary). Constrain by
 * height; the mark is wide (~7.7:1) so `w-auto` keeps the aspect ratio.
 * Usage: <Logo className="h-5" /> in the sidebar, h-6 on the login card.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <img
      src={logoUrl}
      alt="ResetData PRM"
      className={cn("w-auto select-none", className)}
      draggable={false}
    />
  );
}
